module.exports = __webpack_public_path__ + "img/Data0.4d4ce17a.jpg";